import { useEffect, useMemo, useState } from "react";
import DomainRouter from "./router/DomainRouter";
import { AuthProvider } from "./auth/AuthContext";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { getActivePreset, getCustomerTheme } from "./styles/theme/getCustomerTheme";
import type { ThemePreset } from "./styles/theme/types";
import { ThemePresetProvider } from "./styles/theme/ThemePresetContext";

function App() {
  const themeOptions: ThemePreset[] = ["atlas", "circuit"];
  const [preset, setPreset] = useState<ThemePreset>(() => {
    if (typeof window === "undefined") return getActivePreset();
    const stored = window.localStorage.getItem("themePreset") as ThemePreset | null;
    const active = getActivePreset();
    if (stored && themeOptions.includes(stored)) return stored;
    if (themeOptions.includes(active)) return active;
    return "circuit";
  });

  const theme = useMemo(() => getCustomerTheme(preset), [preset]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem("themePreset", preset);
  }, [preset]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ThemePresetProvider value={{ preset, setPreset }}>
        <AuthProvider>
          <DomainRouter />
        </AuthProvider>
      </ThemePresetProvider>
    </ThemeProvider>
  );
}

export default App;
